import React from 'react';

import './tag.less';

const Tag = ({ className = '', children, ...rest }) => {
    const classes = ['tag', className].filter(Boolean).join(' ');
    return (
        <span className={classes} {...rest}>
            {children}
        </span>
    );
};

export default Tag;
